import React from "react";
import RacquetGameTeams from "./RacquetGameTeams.jsx";
import RacquetGameIndividuals from "./RacquetGameIndividuals.jsx";
import "./RacquetGamePublic.css";

function RacquetGamePublic({ game, theme, slug }) {
  if (!game) {
    return (
      <div
        className={`rgpublic-page rgpublic-theme-${theme || "light"}`}
      >
        <div className="rgpublic-empty">
          Game information is unavailable.
        </div>
      </div>
    );
  }

  // ========================================
  // DETERMINE RACQUET GAME TYPE
  // ========================================

  const isIndividualGame = Boolean(
    game.home_player_id ||
    game.away_player_id ||
    game.home_doubles_pair_id ||
    game.away_doubles_pair_id
  );

  // ========================================
  // INDIVIDUAL / DOUBLES PAIR
  // ========================================

  if (isIndividualGame) {
    return (
      <RacquetGameIndividuals
        game={game}
        theme={theme}
        slug={slug}
      />
    );
  }

  // ========================================
  // TEAM GAME
  // ========================================

  return (
    <RacquetGameTeams
      game={game}
      theme={theme}
      slug={slug}
    />
  );
}

export default RacquetGamePublic;